export default {
    icon: "w-8 h-8 text-[2rem] mr-2",
    pcdialog: (context) => {
        console.log(context);
        return {root: {class: "max-w-md"}};
    },
};
